<footer class="style-4">
  <div class="footer-wrapper">
    <div class="container">
      <div class="footer-menu-wrap">
        <div class="row g-lg-4 gy-5">
          <div class="col-lg-4 col-sm-6">
            <div class="footer-widget">
              <div
                class="widget-title"
                data-translation-key="buyer_footer_bidxsell"
              >
                <h4>{{ "buyer_footer.bidxsell" | translate }}</h4>
              </div>

              <div class="menu-container">
                <ul class="widget-list">
                  <li data-translation-key="buyer_footer_home">
                    <a [routerLink]="'/' | localeLink">{{ "buyer_footer.home" | translate }}</a>
                  </li>
                  <!-- <li>
                  <a routerLink="/">{{ 'buyer_footer.how_to_bid_with_us' | translate }}</a>
                </li> -->
                  <li data-translation-key="buyer_footer_how_to_sell_with_us">
                    <a [routerLink]="'/join-as-professional' | localeLink">{{
                      "buyer_footer.how_to_sell_with_us" | translate
                    }}</a>
                  </li>
                  <li data-translation-key="buyer_footer_about_us">
                    <a [routerLink]="'/about-us' | localeLink">{{
                      "buyer_footer.about_us" | translate
                    }}</a>
                  </li>
                  <li data-translation-key="buyer_footer_blogs">
                    <a [routerLink]="'/blogs' | localeLink">{{
                      "buyer_footer.blogs" | translate
                    }}</a>
                  </li>
                  <!-- <li>
                <a routerLink="/">{{ 'buyer_footer.faq' | translate }}</a>
              </li> -->
                  <li data-translation-key="buyer_footer_contact_us">
                    <a [routerLink]="'/contact' | localeLink">{{
                      "buyer_footer.contact_us" | translate
                    }}</a>
                  </li>
                  @if (showKnowledgeBase) {
                  <li data-translation-key="buyer_footer_knowledge_base">
                    <a href="javascript:void(0)" (click)="openKnowledgeBase()">{{
                      "buyer_footer.knowledge_base" | translate
                    }}</a>
                  </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 d-flex align-items-center justify-content-lg-center justify-content-start"
          >
            <div class="footer-logo-area">
              <div class="footer-logo">
                <img src="/assets/images/logo_white.png" alt="" />
              </div>
              <div class="social-area">
                <h5 data-translation-key="buyer_footer_social_connect_title">
                  {{ "buyer_footer.social_connect_title" | translate }}
                </h5>
                <p data-translation-key="buyer_footer_social_connect_note">
                  {{ "buyer_footer.social_connect_note" | translate }}
                </p>
                <ul class="social-list">
                  <!-- <li>
              <a href="https://www.linkedin.com/" target="_blank">
                <i class="bi bi-linkedin"></i>
                <span>{{ 'buyer_footer.social_linkedin' | translate }}</span>
              </a>
            </li> -->
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61558382258535&mibextid=JRoKGi"
                      target="_blank"
                    >
                      <i class="bi bi-facebook"></i>
                      <span
                        data-translation-key="buyer_footer_social_facebook"
                        >{{ "buyer_footer.social_facebook" | translate }}</span
                      >
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/BidxSell_MENA" target="_blank">
                      <i class="bi bi-twitter-x"></i>
                      <span>{{
                        "buyer_footer.social_twitter" | translate
                      }}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/bidxsell?igsh=c3F3MTQzZnI5MXli"
                      target="_blank"
                    >
                      <i class="bi bi-instagram"></i>
                      <span
                        data-translation-key="buyer_footer_social_instagram"
                        >{{ "buyer_footer.social_instagram" | translate }}</span
                      >
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 d-flex justify-content-sm-end justify-content-start"
          >
            <div class="newletter-and-payment-wrap">
              <div class="newletter-area">
                <h4
                  data-translation-key="buyer_footer_join_our_newsletter_more_information"
                >
                  {{
                    "buyer_footer.join_our_newsletter_more_information"
                      | translate
                  }}
                </h4>
                <form (ngSubmit)="onSubscribe()" #subscribeForm="ngForm">
                  <div class="form-inner">
                    <input
                      type="email"
                      name="subscriberEmail"
                      [placeholder]="'buyer_footer.email_address' | translate"
                      [(ngModel)]="subscriberEmail"
                      data-translation-key="buyer_footer_email_address"
                    />
                    <button type="submit" [disabled]="subscribeForm.invalid">
                      @if (localeService.dir == 'ltr') {
                      <i class="bi bi-arrow-right"></i>
                      } @if (localeService.dir == 'rtl') {
                      <i class="bi bi-arrow-left"></i>
                      }
                    </button>
                  </div>
                </form>
              </div>
              <div class="payment-area">
                <h6
                  data-translation-key="buyer_footer_secured_payment_gateways"
                >
                  {{ "buyer_footer.secured_payment_gateways" | translate }}
                </h6>
                <ul class="payment-options">
                  <li>
                    <img src="/assets/images/icon/visa.svg" alt="" />
                  </li>
                  <li>
                    <img src="/assets/images/icon/master-card.svg" alt="" />
                  </li>
                  <li>
                    <img
                      src="/assets/images/icon/american-express.svg"
                      alt=""
                    />
                  </li>
                  <li>
                    <img src="/assets/images/icon/maestro.svg" alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright-area">
          <!-- <p>©Copyright 2023-2025 <a href="index.html">BidXSell</a></p> -->
          <p data-translation-key="buyer_footer_copyright">
            {{ "buyer_footer.copyright" | translate }}
          </p>
        </div>
        <div class="built-by-area text-center">
          <p data-translation-key="buyer_footer_built_by">
            {{ "buyer_footer.built_by" | translate }}
            <a
              href="https://www.silkroad-digital.com/"
              target="_blank"
              rel="noopener"
              >SilkRoad Digital</a
            >
          </p>
        </div>
        <div class="footer-bottom-right">
          <ul>
            <!-- <li>
              <a href="support-center.html">{{ 'buyer_footer.support_center' | translate }}</a>
            </li> -->
            <li>
              <a
                [routerLink]="'/terms-of-use' | localeLink"
                data-translation-key="buyer_footer_terms_and_conditions"
                >{{ "buyer_footer.terms_and_conditions" | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="'/privacy' | localeLink"
                data-translation-key="buyer_footer_footer_privacy_policy"
                >{{ "buyer_footer.footer_privacy_policy" | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
